import { render, staticRenderFns } from "./poll.vue?vue&type=template&id=15c74f37&lang=html"
import script from "./poll.vue?vue&type=script&lang=js"
export * from "./poll.vue?vue&type=script&lang=js"
import style0 from "./poll.vue?vue&type=style&index=0&id=15c74f37&prod&lang=scss"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./poll.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports